<!-- @format -->

<template>
  <Layout>
    <!-- Header -->
    <div class="row">
      <div class="col-11">
        <PageHeader title="RPO Details" />
      </div>
      <div class="col-1 mt-2 float-end">
        <button type="button" onclick="history.back()" class="btn btn-sm btn-outline-dark">
          <i class="bx bx-chevron-left"></i>
          Back
        </button>
      </div>
    </div>
    </hr>
    <!-- Header End -->
    <!-- form -->

    <div class="card">
      <div class="card-body row p-4">
        <div class="col-6">
          <form>
            <div class="mb-3 d-flex">
              <div class="col-4">
                <p>Date</p>
              </div>
              <div class="col-8">
                <input class="form-control inp-bg" />
              </div>
            </div>
            <div class="mb-3 d-flex">
              <div class="col-4">
                <p>Accident location Ch</p>
              </div>
              <div class="col-8">
                <input class="form-control inp-bg" />
              </div>
            </div>
            <div class="mb-3 d-flex">
              <div class="col-4">
                <p>Time Of Accident</p>
              </div>
              <div class="col-8">
                <input class="form-control inp-bg" />
              </div>
            </div>
            <div class="mb-3 d-flex">
              <div class="col-4">
                <p>Time Of Inform</p>
              </div>
              <div class="col-8">
                <input class="form-control inp-bg" />
              </div>
            </div>
            <div class="mb-3 d-flex">
              <div class="col-4">
                <p>Informed By</p>
              </div>
              <div class="col-8">
                <input class="form-control inp-bg" />
              </div>
            </div>
            <div class="mb-3 d-flex">
              <div class="col-4">
                <p>Nature Of Accident</p>
              </div>
              <div class="col-8">
                <input class="form-control inp-bg" />
              </div>
            </div>
            <div class="mb-3 d-flex">
              <div class="col-4">
                <p>Cause Of Accident</p>
              </div>
              <div class="col-8">
                <input class="form-control inp-bg" />
              </div>
            </div>
            <div class="mb-3 d-flex">
              <div class="col-4">
                <p>Classification Of Accident</p>
              </div>
              <div class="col-8">
                <!-- <b-form-select :options="options" class="mt-3"></b-form-select> -->
                <input class="form-control inp-bg" />
              </div>
            </div>
            <div class="mb-3 d-flex">
              <div class="col-4">
                <p>Place</p>
              </div>
              <div class="col-8">
                <input class="form-control inp-bg" />
              </div>
            </div>
            <div class="mb-3 d-flex">
              <div class="col-4">
                <p>Land Mark</p>
              </div>
              <div class="col-8">
                <input class="form-control inp-bg" />
              </div>
            </div>
            <div class="mb-3 d-flex">
              <div class="col-4">
                <p>Lattitude</p>
              </div>
              <div class="col-8">
                <input class="form-control inp-bg" />
              </div>
            </div>
            <div class="mb-3 d-flex">
              <div class="col-4">
                <p>Longitude</p>
              </div>
              <div class="col-8">
                <input class="form-control inp-bg" />
              </div>
            </div>
            <div class="mb-3 d-flex">
              <div class="col-4">
                <p>Arrival time RPV</p>
              </div>
              <div class="col-8">
                <input class="form-control inp-bg" />
              </div>
            </div>
            <div class="mb-3 d-flex">
              <div class="col-4">
                <label>Arrival time Ambulance</label>
              </div>

              <div class="col-8">
                <input class="form-control inp-bg" />
              </div>
            </div>
            <div class="mb-3 d-flex">
              <div class="col-4">
                <p>Arrival time Crane</p>
              </div>
              <div class="col-8">
                <input class="form-control inp-bg" />
              </div>
            </div>
          </form>
        </div>
        <div class="col-6">
          <div class="mb-3 d-flex">
            <div class="col-4">
              <p>Arrival time Fire Bridade</p>
            </div>
            <div class="col-8">
              <input class="form-control inp-bg" />
            </div>
          </div>
          <div class="mb-3 d-flex">
            <div class="col-4">
              <p>Location Of RVP/Ambulane/Crane At Time Of Accident</p>
            </div>
            <div class="col-8">
              <input class="form-control inp-bg" />
            </div>
          </div>
          <div class="mb-3 d-flex">
            <div class="col-4">
              <p>Road Condition</p>
            </div>
            <div class="col-8">
              <input class="form-control inp-bg" />
            </div>
          </div>
          <div class="mb-3 d-flex">
            <div class="col-4">
              <p>Weather Condition</p>
            </div>
            <div class="col-8">
              <input class="form-control inp-bg" />
            </div>
          </div>
          <div class="mb-3 d-flex">
            <div class="col-4">
              <p>Patient Admitted To Hospital Name</p>
            </div>
            <div class="col-8">
              <input class="form-control inp-bg" />
            </div>
          </div>
          <div class="mb-3 d-flex">
            <div class="col-4">
              <p>Vehicle Responsible</p>
            </div>
            <div class="col-8">
              <input class="form-control inp-bg" />
            </div>
          </div>
          <div class="mb-3 d-flex">
            <div class="col-4">
              <p>Help Provided By</p>
            </div>
            <div class="col-8">
              <input class="form-control inp-bg" />
            </div>
          </div>
          <div class="mb-3 d-flex">
            <div class="col-4">
              <p>name Of Driver</p>
            </div>
            <div class="col-8">
              <input class="form-control inp-bg" />
            </div>
          </div>
          <div class="mb-3 d-flex">
            <div class="col-4">
              <p>Mobile Number Of Driver</p>
            </div>
            <div class="col-8">
              <input class="form-control inp-bg" />
            </div>
          </div>
          <div class="mb-3 d-flex">
            <div class="col-4">
              <p>Driver Adress</p>
            </div>
            <div class="col-8">
              <input class="form-control inp-bg" />
            </div>
          </div>
          <div class="mb-3 d-flex">
            <div class="col-4">
              <p>Origin And Destination</p>
            </div>
            <div class="col-8">
              <input class="form-control inp-bg" />
            </div>
          </div>
          <div class="mb-3 d-flex">
            <div class="col-4">
              <p>Nearest Police Station Name</p>
            </div>
            <div class="col-8">
              <input class="form-control inp-bg" />
            </div>
          </div>
          <div class="mb-3 d-flex">
            <div class="col-4">
              <p>Property Damage Details</p>
            </div>
            <div class="col-8">
              <input class="form-control inp-bg" />
            </div>
          </div>
          <div class="mb-3 d-flex">
            <div class="col-4">
              <p>Action Taken</p>
            </div>
            <div class="col-8">
              <input class="form-control inp-bg" />
            </div>
          </div>
        </div>
        <hr />
        <div class="row">
          <div class="col-12 text-center">
            <button type="button" class="btn btn-success btn-block " @click="">
              <i class="fas fa-check"></i> Save
            </button>
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>
<script>
import Layout from "@/layouts/main";
import PageHeader from "@/components/page-header";

export default {
  data() {
    return {
      FormDataObj: {},
    };
  },
  components: {
    Layout,
    PageHeader,
  },
};
</script>
